<template>
    <div class="modal fade" id="giphy-library" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-575 modal-top-spacing">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Add a GIF</h2>
                    <div class="gt-modal-close" @click="closeModal">
                        <a href="javascript:void(0);">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13"></path>
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1"></path>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="gt-md-modal-content text-center pb-0 pt-3 pl-4 pr-4">
                    <div class="mt-library-tabs">
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="tab-giphy" role="tabpanel" aria-labelledby="giphy-tab">
                                <div class="theme-tab-inner">
                                    <div class="image-search">
                                        <input placeholder="Search Library..."
                                               class="search-library-input"
                                               @keyup="delayedSearch"
                                               v-model="giphySearch"
                                               maxlength="45"
                                               type="text"
                                               autocomplete="off">
                                        <div id="giphyApiSearchLoader" class="loader" :class="{ hidden: !loading }"></div>
                                    </div>
                                    <ul class="giphy-col" id="giphyInviteImagesContainer">
                                        <li v-for="gif in gifs" :key="gif.id" class="img-item22" @click="selectGif(gif)">
                                            <a href="javascript:void(0)">
                                                <img :src="gif.images.downsized_medium.url" alt="GIF image">
                                                <span class="theme-btn-lite">select</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="group-card-browse-library" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-575 modal-top-spacing">
            <div class="modal-content">
                <div class="gt-md-modal-header">
                    <h2>Choose an image</h2>
                    <div class="gt-modal-close" data-dismiss="modal">
                        <a href="javascript:void(0);">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" width="14" height="14">
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 13 1 L 7 7 L 13 13"></path>
                                <path stroke="#1e2437" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M 1 13 L 7 7 L 1 1"></path>
                            </svg>
                        </a>
                    </div>
                </div>
                <!-- modal-header -->
                <div class="gt-md-modal-content text-center pb-0 pt-3 pl-4 pr-4">
                    <div class="mt-library-tabs">
                        <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a href="javascript:void(0)" class="nav-link active" id="giphy-tab" data-toggle="tab" data-target="#giphy" role="tab" aria-controls="giphy" aria-selected="true">Giphy</a>
                            </li>
                            <!-- Giphy tab -->
                            <li class="nav-item" role="presentation">
                                <a href="javascript:void(0)" class="nav-link" id="unsplash-tab" data-toggle="tab" data-target="#unsplash" role="tab" aria-controls="unsplash" aria-selected="false">Unsplash</a>
                            </li>
                            <!-- Unsplash tab -->
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="giphy" role="tabpanel" aria-labelledby="giphy-tab">
                                <div class="theme-tab-inner">
                                    <div class="image-search">
                                        <input placeholder="Search Library..." class="search-library-input" @keyup="searchGiphy" v-model="giphySearch" maxlength="45" type="text" autocomplete="off">
                                        <div id="giphyApiSearchLoader" class="loader hidden"></div>
                                    </div>
                                    <ul class="giphy-col" v-if="giphy">
                                        <li v-for="(item, index) in giphyData">
                                            <a href="javascript:void(0)" @click="selectImage(item.images.downsized.url)">
                                                <img :src="item.images.downsized.url" alt="GIF image">
                                                <span class="theme-btn-lite">select</span>
                                            </a>
                                        </li>
                                        <!-- item-->
                                    </ul>
                                    <!-- giphy-col -->
                                </div>
                                <!-- mt-library-content -->
                            </div>
                            <div class="tab-pane fade" id="unsplash" role="tabpanel" aria-labelledby="unsplash-tab">
                                <div class="theme-tab-inner">
                                    <div class="image-search">
                                        <input placeholder="Search Library..." class="search-library-input" @keyup="searchUnsplash" v-model="unsplashSearch" maxlength="45" type="text">
                                        <div id="unsplashApiSearchLoader" class="loader hidden"></div>
                                    </div>
                                    <ul class="giphy-col" v-if="unsplash">
                                        <li v-for="(item, index) in usplashData">
                                            <a href="javascript:void(0)" @click="selectImage(item.urls.small)">
                                                <img :src="item.urls.small" alt="Image">
                                                <span class="theme-btn-lite">select</span>
                                            </a>
                                        </li>
                                        <!-- item-->
                                    </ul>
                                    <!-- giphy-col -->
                                </div>
                                <!-- mt-library-content -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- gt-md-modal-content -->
            </div>
        </div>
    </div>
</template>

<script>
     let delayTimer = null
    export default {
        data() {
            return {
                giphy: null,
                unsplash: null,
                unsplashSearch: "",
                giphySearch: '',
                gifs: [],
                loading: false,
                delayTimer: null,
            };
        },
         mounted: function () {
            this.fetchTrendingGifs();
            this.loadGiphy();
            this.loadUnsplash();
        },
        methods: {
            searchGiphy() {
                $("#giphyApiSearchLoader").removeClass("hidden")
                clearTimeout(delayTimer);
                let that = this
                delayTimer = setTimeout(function () {
                    if (that.giphySearch) {
                        that.giphy = null
                        fetch('https://api.giphy.com/v1/gifs/search?q=' + that.giphySearch + '&limit=50&api_key=9I6dSsevBQv5ruvT63gKFYV1yRj1YX04&rating=pg')
                            .then((res) => res.json())
                            .then((data) => {
                                that.giphy = data
                                $("#giphyApiSearchLoader").addClass("hidden")
                            })
                            .catch(err => console.log(err.message))
                    } else {
                        $("#giphyApiSearchLoader").addClass("hidden")
                    }
                }, 1500);
            },
            async loadGiphy() {
                await fetch('https://api.giphy.com/v1/gifs/trending?limit=50&api_key=9I6dSsevBQv5ruvT63gKFYV1yRj1YX04&rating=pg')
                    .then((res) => res.json())
                    .then((data) => {
                        this.giphy = data
                    })
                    .catch(err => console.log(err.message))
            },
            async loadUnsplash() {
                await fetch('https://api.unsplash.com/photos/?page=1&orientation=squarish&client_id=aGa7_M0WWNIGvMQhCLSTI-gA_3vO-2Emr2K3iCvqfA0')
                    .then((res) => res.json())
                    .then((data) => {
                        this.unsplash = data
                    })
                    .catch(err => console.log(err.message))
            },
            selectImage(imageUrl) {
                this.$emit('update-image', imageUrl)
                $("#group-card-browse-library").modal("hide")
            },
            fetchTrendingGifs() {
                this.loading = true;
                fetch('https://api.giphy.com/v1/gifs/trending?limit=50&api_key=9I6dSsevBQv5ruvT63gKFYV1yRj1YX04&rating=pg')
                    .then(response => response.json())
                    .then(data => {
                        this.gifs = data.data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.error("API call failed: ", error);
                        this.loading = false;
                    });
            },
            searchApi() {
                if (!this.giphySearch) {
                    this.fetchTrendingGifs();
                    return;
                }
                this.loading = true;
                fetch(`https://api.giphy.com/v1/gifs/search?q=${this.giphySearch}&limit=50&api_key=9I6dSsevBQv5ruvT63gKFYV1yRj1YX04&rating=pg`)
                    .then(response => response.json())
                    .then(data => {
                        this.gifs = data.data;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.error(error);
                        this.loading = false;
                    });
            },
            delayedSearch() {
                clearTimeout(this.delayTimer);
                this.delayTimer = setTimeout(this.searchApi, 1500);
            },
            selectGif(gif) {
                const event = new CustomEvent('gif-selected', { detail: gif });
                document.dispatchEvent(event);
                $('#giphy-library').modal('hide');
            },
            closeModal() {
                $('#giphy-library').modal('hide');
            },
            searchUnsplash() {
                $("#unsplashApiSearchLoader").removeClass("hidden")
                clearTimeout(delayTimer);
                let that = this
                delayTimer = setTimeout(function () {
                    if (that.unsplashSearch) {
                        that.unsplash = null
                        fetch('https://api.unsplash.com/search/photos/?page=1&orientation=squarish&client_id=aGa7_M0WWNIGvMQhCLSTI-gA_3vO-2Emr2K3iCvqfA0&query=' + that.unsplashSearch)
                            .then((res) => res.json())
                            .then((data) => {
                                that.unsplash = data.results
                                $("#unsplashApiSearchLoader").addClass("hidden")
                            })
                            .catch(err => console.log(err.message))
                    } else {
                        $("#unsplashApiSearchLoader").addClass("hidden")
                    }
                }, 1500);
        },

        },
        computed: {
            giphyData() {
                return this.giphy.data
            },
            usplashData() {
                return this.unsplash
            },
        },
    };
    
</script>

<style scoped>
    .loader {
        border: 2px solid #f3f3f3;
        border-top: 2px solid #05eaed;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 1s linear infinite;
        position: absolute;
        right: 9px;
        top: 9px;
    }

    @-moz-keyframes spin {
        from {
            -moz-transform: rotate(0deg);
        }

        to {
            -moz-transform: rotate(360deg);
        }
    }

    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }

        to {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .hidden {
        display: none;
    }
</style>